import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/comment-management`;

export const commentManagementRoutesObj = {
  list: baseRoute,
} as const;

export type ICommentManagementRouteParams = IExtractRouteParamMap<
  typeof commentManagementRoutesObj
>;

export const commentManagementPath = createPaths<
  typeof commentManagementRoutesObj,
  ICommentManagementRouteParams
>(commentManagementRoutesObj);
